import { render, staticRenderFns } from "./productlist_A.vue?vue&type=template&id=3a017c1e&scoped=true&"
import script from "./productlist_A.vue?vue&type=script&lang=js&"
export * from "./productlist_A.vue?vue&type=script&lang=js&"
import style0 from "./productlist_A.vue?vue&type=style&index=0&id=3a017c1e&lang=scss&scoped=true&"
import style1 from "./productlist_A.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a017c1e",
  null
  
)

export default component.exports